module.exports = __webpack_public_path__ + "static/media/response.a2124e5e.png";